module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_07_american-village-2add4dd33c098537b8202943d021a90d.jpg";